import { AxiosInstance } from 'axios'
import { IJsonApiSerializer } from '../JsonApiSerializer'

class PostVideoService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public async createPostVideo(formData) {
    const { data } = await this.httpClient.post(`/agent/api/post_videos`, formData)
    const createdPostVideo = this.serializer.parseResourceData(
      data.post_video,
      data.post_video.data
    )

    return { createdPostVideo, flush: data.flush }
  }

  public async updatePostVideo(id, formData) {
    const { data } = await this.httpClient.patch(`/agent/api/post_videos/${id}`, formData)
    const updatedPostVideo = this.serializer.parseResourceData(
      data.post_video,
      data.post_video.data
    )

    return { updatedPostVideo, flush: data.flush }
  }

  public async deletePostVideo(id) {
    const { data } = await this.httpClient.delete(`/agent/api/post_videos/${id}`)

    return { flush: data.flush }
  }
}

export default PostVideoService
